import { DialogModalStyles, EventModalTypes } from "../DialogModalWrapper";
import { useDispatch, useSelector } from "react-redux";
import { useTheme, DialogContent, DialogActions } from "@mui/material";
import { useCallback } from "react";
import { ModalTitle, ModalMessage, ModalButton } from "../DialogModalComponents";
import { openSnackbar } from "src/redux/actions/App.Actions";
import { swapAircraftBySelectedEvent } from "src/components/Flights/helper";

interface ISwapFlightModalProps {
  isOpen: boolean;
  handleClose: (value: boolean) => void;
  setActiveEventModal: (EventModalTypes: EventModalTypes) => void;
  modalProps: any;
  isFlight: boolean;
}

export const SwapFlightModal = (props: ISwapFlightModalProps): JSX.Element => {
  const { isOpen, handleClose, setActiveEventModal, modalProps, isFlight } = props;
  const { selectedFlights, selectedEventsAircraft, allAircrafts, setBatchId1, setBatchId2 } = modalProps;
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleCancel = useCallback((): void => {
    handleClose(false);
    setActiveEventModal(EventModalTypes.None);
  }, [handleClose, setActiveEventModal]);

  const handleConfirm = useCallback((): void => {
    const swap = async (): Promise<void> => {
      dispatch(
        openSnackbar({
          open: true,
          closeDelay: 3000,
          variant: "info",
          message: "Swapping aircrafts...",
        })
      );
      const response = await swapAircraftBySelectedEvent(
        selectedFlights,
        selectedEventsAircraft,
        allAircrafts,
        isFlight
      );
      setBatchId1(response.batchId1);
      setBatchId2(response.batchId2);
    };
    swap();
    handleClose(false);
    setActiveEventModal(EventModalTypes.None);
  }, [
    allAircrafts,
    dispatch,
    handleClose,
    selectedEventsAircraft,
    selectedFlights,
    setActiveEventModal,
    setBatchId1,
    setBatchId2,
    isFlight,
  ]);

  if (isOpen) {
    return (
      <DialogContent sx={DialogModalStyles(theme)}>
        <div className="modal_content">
          <ModalTitle title="Swap Aircraft Flights"></ModalTitle>
          <ModalMessage message={"Are you sure you would like to swap these flights?"}></ModalMessage>
          <DialogActions>
            <ModalButton label={"Cancel"} handler={handleCancel}></ModalButton>
            <ModalButton label={"Confirm"} handler={handleConfirm}></ModalButton>
          </DialogActions>
        </div>
      </DialogContent>
    );
  } else {
    return <></>;
  }
};
